import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { MODULES } from "../modules";
import { PageHeader, Card } from "./ui";
import { ChevronRight } from "lucide-react";

const REGISTER_KEYS = [
  "use-cases", "tasks", "approvals", "regulatory", "cyber-gov", "incidents",
  "ai-readiness", "ai-projects", "business-impact", "kri", "kpi", "business-value",
  "soc", "app-perf", "net-perf", "soar", "integrations", "users",
];

export default function Registers() {
  const { t } = useI18n();
  return (
    <div className="space-y-6">
      <PageHeader title={t("registers")} subtitle="All domain registers in one place" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REGISTER_KEYS.map((k) => {
          const cfg = MODULES[k];
          if (!cfg) return null;
          const Icon = cfg.icon;
          const route = k === "incidents" ? "/app/soc" : `/app/${k}`;
          return (
            <Link key={k} to={route} className="block">
              <Card className="p-5 hover:shadow-md transition-shadow group">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-teal-50 flex items-center justify-center flex-shrink-0"><Icon className="w-5 h-5 text-teal-700" /></div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-slate-900 truncate">{t(cfg.labelKey)}</p>
                    <p className="text-xs text-slate-400 capitalize">{cfg.entity.replace(/_/g, " ")}</p>
                  </div>
                  <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-teal-600 transition-colors rtl:rotate-180" />
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
